module.exports = __webpack_public_path__ + "img/uwa-logo.4330042a.jpg";